import { render } from "./journaliesVAT.vue?vue&type=template&id=3e456f3f"
import script from "./journaliesVAT.vue?vue&type=script&lang=js"
export * from "./journaliesVAT.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__